import type { Activity } from "@career-ops-amplify/shared";

const WEIGHT: Record<string, number> = { S: 1, M: 2, L: 3 };

export function effortWeightValue(weight?: string): number {
  return WEIGHT[weight ?? "M"] ?? 2;
}

/** Weighted average of work progressPercent by effortWeight. */
export function suggestedProgressFromWork(work: Activity[]): number | null {
  if (work.length === 0) return null;
  let totalW = 0;
  let acc = 0;
  for (const w of work) {
    const weight = effortWeightValue(w.effortWeight);
    const pct =
      w.state === "done"
        ? 100
        : typeof w.progressPercent === "number"
          ? w.progressPercent
          : 0;
    acc += pct * weight;
    totalW += weight;
  }
  if (totalW === 0) return null;
  return Math.round(acc / totalW);
}

export function isOpenWork(state: string | undefined): boolean {
  return state === "planned" || state === "due";
}

export function formatConfidence(value?: string): string | null {
  if (!value) return null;
  return value.charAt(0).toUpperCase() + value.slice(1);
}
